import { addWeeks, setHours, startOfHour } from 'date-fns';

export class NewEvent {
	name = '';
	begin: Date = addWeeks(startOfHour(setHours(new Date(), 19)), 1);
	price = 0;
	description = '';
	location = '';
	owners: string[] = [];
	guests: Guest[] = [];
	slug = '';
	coverImageUrl = '';
}

export class Event extends NewEvent {
	id = '';
	ownerSecret = '';
	owners: string[] = [];
	bring: BringItem[] = [];
	guests: Guest[] = [];
	guestsInteracted: string[] = [];
}

export interface BringItem {
	text: string;
	guestId: string;
}

export interface Guest {
	id: string;
	name: string;
	email: string;
	attending: Attending;
	created: Date | null;
	comment: string | null;
}

export enum Attending {
	MAYBE = 'MAYBE',
	ATTENDING = 'ATTENDING',
	NOT_ATTENDING = 'NOT_ATTENDING',
	UNKNOWN = 'UNKNOWN',
	WAITLIST = 'WAITLIST',
}

export enum ContactPreference {
	PHONE = 'phone',
	EMAIL = 'email',
	NONE = 'none',
}